// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"1e1ee22e","102":"a19002b8","453":"6a2b3701","628":"28850534","805":"ac369fb1","905":"3ee2bdc0"}[chunkId] + ".chunk.js";
};